import {RootState} from 'store'
import type {LangType, MessagesType} from 'src/lib/translates/types'

export const getLang =
  (state: RootState): LangType =>
    state.translates.lang

export const getTranslates =
  (state: RootState): MessagesType =>
    state.translates.messages
